var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6066 3.50769C26.9971 3.11717 27.6302 3.11717 28.0208 3.50769L28.4922 3.9791C28.8827 4.36962 28.8827 5.00279 28.4922 5.39331L17.8856 15.9999L28.4922 26.6065C28.8827 26.997 28.8827 27.6302 28.4922 28.0207L28.0208 28.4921C27.6302 28.8827 26.9971 28.8827 26.6066 28.4921L16 17.8855L5.39335 28.4921C5.00283 28.8827 4.36966 28.8827 3.97914 28.4921L3.50774 28.0207C3.11721 27.6302 3.11721 26.997 3.50774 26.6065L14.1143 15.9999L3.50774 5.39331C3.11721 5.00279 3.11721 4.36962 3.50774 3.9791L3.97914 3.50769C4.36966 3.11717 5.00283 3.11717 5.39335 3.50769L16 14.1143L26.6066 3.50769Z",
    fill: "#979092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7e498ebfdfaf674fc4ee985c13d512a4.svg";
export { ForwardRef as ReactComponent };